import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { PaginationState } from '@tanstack/react-table';
import { ActiveUserData } from '@/api';

interface ActiveUsersListState {
  activeUsersList: ActiveUserData[];
  activeUsersListRowCount: number;
  activeUsersListPagination: PaginationState;
}

const initialState: ActiveUsersListState = {
  activeUsersList: [],
  activeUsersListRowCount: 0,
  activeUsersListPagination: {
    pageIndex: 0,
    pageSize: 50
  }
};

const activeUsersSlice = createSlice({
  name: 'activeUsers',
  initialState: initialState,
  reducers: {
    setActiveUsersList: (state, action: PayloadAction<ActiveUserData[]>) => {
      state.activeUsersList = action.payload;
    },
    setActiveUsersRowCount: (state, action: PayloadAction<number>) => {
      state.activeUsersListRowCount = action.payload;
    },
    setActiveUsersPagination: (state, action: PayloadAction<PaginationState>) => {
      state.activeUsersListPagination = action.payload;
    }
  }
});

export const { setActiveUsersList, setActiveUsersRowCount, setActiveUsersPagination } = activeUsersSlice.actions;

export const selectActiveUsersList = (state: RootState) => {
  return state.activeUsers.activeUsersList;
};
export const selectActiveUsersRowCount = (state: RootState) => {
  return state.activeUsers.activeUsersListRowCount;
};
export const selectActiveUsersPagination = (state: RootState) => {
  return state.activeUsers.activeUsersListPagination;
};

export const activeUsersReducer = activeUsersSlice.reducer;
